import {UIGameMapController} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapController.ts'
import {UIGameMapHoverController} from '../../../../shared/scripts/ui_game/ui_game_map/ui_game_map_hover/UIGameMapHoverController.ts'
import {UIGameMapView} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapView.ts'
import {type UIMGameManager} from '../UIMGameManager.ts'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIGameConstants} from '../../../../shared/scripts/ui_game/UIGameConstants.ts'

export class UIMGameMapController extends UIGameMapController {
    constructor(uiGameManager: UIMGameManager) {
        super(uiGameManager)
        this.hoverController = new UIGameMapHoverController(uiGameManager, false)
    }

    initializeMapView(): UIGameMapView {
        const canvas = this.uiGameManager.canvasController

        const width = canvas.appW - canvas.chatWidth
        const height = canvas.appH - canvas.itemSize
        return new UIGameMapView(0, 0, width, height, canvas.app)
    }

    protected resizeMapView(): void {
        const canvas = this.uiGameManager.canvasController

        const width = canvas.appW - canvas.chatWidth
        const height = canvas.appH - canvas.itemSize
        this.mapView.resize(width, height)
        this.adjustMapPosition()
    }

    private adjustMapPosition(): void {
        if(UIUtilsEjsVariables.isUserOnTabletApp) return
        const scaleFactor = this.mapView.scale.x

        const clamp = this.mapView.plugins.get('clamp')?.options

        let horzOffset: number = 0
        if(clamp == undefined || typeof clamp.left == 'boolean' || typeof clamp.right == 'boolean') {
            horzOffset = 0
        } else {
            horzOffset = Math.round(clamp?.left ?? 0) + Math.round(clamp?.right ?? 0)
        }
        this.mapView.left = -this.mapView.screenWidth / 2 / scaleFactor + horzOffset / 2
        this.mapView.top = -this.mapView.screenHeight / 1.75 / scaleFactor
    }

    private adjustMapScale(): void {
        if(UIUtilsEjsVariables.isUserOnTabletApp) return
        const scaleFactor = this.mapView.screenWidth / this.mapView.worldWidth * UIGameConstants.GAME_WORLD_ZOOM_CLAMP_MULTIPLIER
        this.mapView.scale.set(scaleFactor)
    }

    createMap(): void {
        super.createMap()
        this.adjustMapScale()
        this.mapView.emit('zoomed', this.mapView.DEFAULT_ZOOM_EVENT)
        this.adjustMapPosition()
    }
}
